import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { api, saveAuth } from "../lib/api";

export default function Register() {
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      saveAuth(data.token, data.user);
      toast.success("Welcome to AHCCT!");
      nav("/"); window.location.reload();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="fade-in min-h-[70vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#eae5d9] p-8 md:p-10">
        <h1 className="serif text-3xl font-semibold text-[#000080]">Create your account</h1>
        <p className="text-sm text-[#737373] mt-1 mb-6">Join thousands of kind people making change happen.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <Input required placeholder="Full Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
          <Input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
          <Input placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="register-phone" />
          <Input required type="password" placeholder="Password (min 6 chars)" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
          <Button type="submit" disabled={loading} className="w-full bg-[#FF9933] hover:bg-[#E68A2E] text-white h-12 rounded-full btn-glow" data-testid="register-submit">
            {loading ? "Creating..." : "Create Account"}
          </Button>
        </form>
        <p className="text-sm text-center text-[#737373] mt-6">
          Have an account? <Link to="/login" className="text-[#FF9933] font-semibold" data-testid="register-to-login">Login</Link>
        </p>
      </div>
    </div>
  );
}
